/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Authenticated`)
};

const zh_hans1_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未认证`)
};

const zh_hant1_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未驗證`)
};

const fr_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non authentifié`)
};

const de_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht authentifiziert`)
};

const ja_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未認証`)
};

const ko_settings_not_authenticated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증되지 않음`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_not_authenticated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_not_authenticated(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_not_authenticated", locale)
	if (locale === "en") return en_settings_not_authenticated(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_not_authenticated(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_not_authenticated(inputs)
	if (locale === "fr") return fr_settings_not_authenticated(inputs)
	if (locale === "de") return de_settings_not_authenticated(inputs)
	if (locale === "ja") return ja_settings_not_authenticated(inputs)
	return ko_settings_not_authenticated(inputs)
};